import { useMutation, useQueryClient } from '@tanstack/react-query'
import { publishMeeting } from '../api/meetingApi'

/**
 * Taslak tutanağı Yayınla (044/1.13) — Toplantı Detay üst çubuğundaki buton. Durum 360→361 + standart PDF.
 * Başarıda detay + grup listeleri (kart sayıları) tazelenir; ayrıca kayıt <b>Taslaklar</b> listesinden düşüp
 * grubun toplantı listesine girdiğinden bu iki liste de geçersizleştirilir (aksi halde bayat kalırdı). Hata
 * global onError ile toast'lanır (409 = arşivli veya zaten yayınlı).
 */
export function usePublishMeeting(meetingId: number) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => publishMeeting(meetingId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['meeting-detail', meetingId] })
      qc.invalidateQueries({ queryKey: ['meeting-groups'] })
      qc.invalidateQueries({ queryKey: ['draft-meetings'] })
      qc.invalidateQueries({ queryKey: ['group-meetings'] })
    },
  })
}
